import { Component, Output, EventEmitter } from '@angular/core';

import { SnShare } from '@lib/api/entities';
import { snFadeIn, snFadeOut, snListStagger } from '@lib/common/animations';
import { SnListBaseComponent } from '@lib/core';

@Component({
  selector: 'sn-sharing-list',
  templateUrl: './share-list.component.html',
  styleUrls: ['./share-list.component.scss'],
  animations: [snFadeIn, snFadeOut, snListStagger],
})
export class SnShareListComponent extends SnListBaseComponent<SnShare> {
  @Output()
  public readonly editShareAccessibility = new EventEmitter<Partial<SnShare>>();

  constructor() {
    super();
  }

  public trackBy(index: number, item: SnShare): any {
    return item.id;
  }
}
